import React, {Component} from "react";
import BlockDatargrid from "./block/BlockDatargrid";
import BlockForm from "./block/BlockForm";
import SpecificBlockOption from "./specific/SpecificBlockOption";
import SpecificBlockPrice from "./specific/SpecificBlockPrice";

class Screen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            height: 0
        }
    }

    getComponent(block) {
        switch (block.view) {
            case '/public/jsp/core/block/blockForm.jsp' : return BlockForm;
            case '/public/jsp/core/block/blockDatagrid.jsp' : return BlockDatargrid;
            case '/public/jsp/core/specific/block/SpecificBlockOption.jsp' : return SpecificBlockOption;
            case '/public/jsp/core/specific/block/SpecificBlockPrice.jsp' : return SpecificBlockPrice;
        }
        return null;
    }

    render() {
        return (
            <div className="coreScreen">
                {this.props.screen.blocks.map(block => {
                    const ComponentName = this.getComponent(block);
                    if (ComponentName !== null) {
                        return (
                            <div key={block.id} className={block.class} style={JSON.parse(!(block.style) ? "{}" : block.style)}>
                                {!!(block.title1) &&
                                <div className="coreBlock-header">
                                    <span className="coreBlock-title1">{block.title1}</span><br/>
                                    <span className="coreBlock-title2">{block.title2}</span>
                                </div>
                                }

                                <div className="coreBlock-content">
                                    <ComponentName
                                        block={block}
                                        onChange={this.props.onChange}
                                        externalCall={this.props.externalCall}
                                        primaryKey={this.props.primaryKey}/>
                                </div>
                            </div>
                        )
                    }
                })}
            </div>
        );
    }
}

export default Screen;
